export const SUPER_SEARCH_COMMANDS = {
  BULK_ACTIONS: 'bulk-actions',
  CREATE_COMPANY: 'create-company',
  CREATE_MEASUREMENT_DATE: 'create-measurement-date',
  EXCEL_EXPORT: 'excel-export',
  OPEN_NOTIFICATIONS: 'open-notifications',
  PDF_EXPORT: 'pdf-export',
  START_GUIDED_TOUR: 'start-guided-tour',
} as const;

export const SUPER_SEARCH_NAVIGATION_DELAY_MS = 500;

export type SuperSearchCommand = (typeof SUPER_SEARCH_COMMANDS)[keyof typeof SUPER_SEARCH_COMMANDS];
